import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import * as D from '../../deps';

import BackstagePodcastEpisodeListItem from './BackstagePodcastEpisodeListItem';

const integrationData = {
  contentSection: D.Constants.ContentSections.BackstageContentSections.EPISODE_LIST,
};
const getListItemProps = (_, index) => ({ index, hasBorderTopBottom: true });

const BackstagePodcastEpisodesList = props => {
  return (
    <D.Utils.Context.AppContextIntegrationData data={integrationData}>
      <D.BackstageItemList
        sourceItems={props.episodes}
        elementHeight={D.RowItemHeights.LARGE}
        generateListItemProps={getListItemProps}
        listItemComponent={BackstagePodcastEpisodeListItem}
        numPlaceholders={props.numPlaceholders}
      />
    </D.Utils.Context.AppContextIntegrationData>
  );
};

BackstagePodcastEpisodesList.propTypes = {
  episodes: ImmutablePropTypes.listOf(PropTypes.string),
  numPlaceholders: PropTypes.number,
};

export default D.withVisibilityLogger(integrationData, {
  staticHeight: D.RowItemHeights.LARGE,
  useMemo: true,
})(BackstagePodcastEpisodesList);
